import { SvgIcon } from "@mui/material"
import React from "react"

interface IProps {
  sx?: any
}

export function IconFondations(props: Readonly<IProps>): React.JSX.Element {
  const { sx } = props

  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={2}
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      stroke="currentColor"
      sx={{
        width: sx?.width ? sx?.width : "24",
        height: sx?.height ? sx?.height : "24",
      }}>
      <path d="M200-120v-160h-80v-80h80v-166L88-440l-48-64 440-336 440 336-48 64-112-86v166h80v80h-80v160h-80v-160H520v160h-80v-160H280v160h-80Zm80-240h160v-349L280-587v227Zm240 0h160v-227L520-709v349Z" />
    </SvgIcon>
  )
}
